<template>
  <div>
    <div
      :class="{ 'pointer-events-auto cursor-pointer': !isLoggedIn }"
      @click="showLoginModalIfNotLoggedIn"
    >
      <div :class="{ 'pointer-events-none': !isLoggedIn }">
        <slot />
      </div>
    </div>
    <LazyLoginModal
      v-if="isSingleFinderActive"
      :visible="isLoginModalVisible"
      @update:visible="isLoginModalVisible = $event"
    />
  </div>
</template>

<script setup>
const userStore = useUserStore()

const {
  isLoggedIn,
} = storeToRefs(userStore)

const { isSingleFinderActive } = await useSingleFinder()

const isLoginModalVisible = ref(false)

const showLoginModalIfNotLoggedIn = () => {
  if (isLoggedIn.value) {
    return
  }

  isLoginModalVisible.value = true
}
</script>